export const createPaymentProfileMutation = `
    mutation createPaymentProfile($input: CreatePaymentProfileInput!) {
        createPaymentProfile(input: $input) {
            id
            name
            customerId
            billingProviderId
            providerPaymentMethodId
            status
        }
    }
`;

export const deletePaymentProfileMutation = `
    mutation deletePaymentProfile($input: DeletePaymentProfileInput!) {
        deletePaymentProfile(input: $input) {
            id
        }
    }
`;

export const initializePaymentProfileSetupMutation = `
    mutation initializePaymentProfileSetup($input: InitializePaymentProfileSetupInput!) {
        initializePaymentProfileSetup(input: $input) {
            sessionId
            providerType
            clientToken
            providerCustomerId
            status
            expiresAt
            metadata
        }
    }
`;

export const confirmPaymentProfileSetupMutation = `
    mutation confirmPaymentProfileSetup($input: ConfirmPaymentProfileSetupInput!) {
        confirmPaymentProfileSetup(input: $input) {
            id
            name
            customerId
            billingProviderId
            providerPaymentMethodId
            status
        }
    }
`;
